import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Card, Table, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Switch, Button } from "@mui/material";
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";
import personOutline from "@iconify/icons-eva/person-outline";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import iconEdit from "@iconify/icons-eva/edit-2-fill";

import axios from "axios";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Confirm from "src/components/common/ConfirmDialog";
import TopupDialog from "src/components/dialogs/TopupDialog";
import PointTopupDialog from "src/components/dialogs/PointTopupDialog";
import UserChargeDialog from "src/components/dialogs/UserChargeDialog";
import UIAvatar from "src/components/common/UIAvatar";
import { asyncRequest } from "src/services/network";
import SharesDialog from "src/components/dialogs/SharesDialog";
import UserInfo from "src/components/common/UserInfo";
import PointReleaseDialog from "src/components/dialogs/PointReleaseDialog";
import SalaryDialog from "src/components/dialogs/SalaryDialog";
import TitleDialog from "src/components/dialogs/TitleDialog";
import TreeSelect from "src/components/lib/tree-select/TreeSelect";
import StaffAddDialog from "src/components/dialogs/StaffAddDialog";
import TiejunAddDialog from "./components/TiejunAddDialog";
import { TIEJUN_LEVEL_MAP } from "src/config/constants";
import BindTeijunParentDialog from "./components/BindTeijunParentDialog";
import TiejunEditDialog from "./components/TiejunEditDialog";
import Label from "src/components/Label";

const TABLE_HEAD = [
  { id: "uid", label: "用户", alignRight: false },
  // { id: "realname", label: "真实姓名", alignRight: false },
  // { id: "mobile", label: "手机号", alignRight: false },
  { id: "level", label: "当前等级", alignRight: false },
  // { id: "ratio", label: "提成", alignRight: false },
  // { id: "balance", label: "消费券", alignRight: false },
  // { id: "points", label: "积分", alignRight: false },
  // { id: "points", label: "未发放消费券", alignRight: false },
  { id: "lastMonthly2", label: "上上月", alignRight: false },
  { id: "lastMonthly", label: "上月", alignRight: false },
  { id: "monthly", label: "本月", alignRight: false },
  // { id: "status", label: "达标情况", alignRight: false },
  // { id: "createdAt", label: "注册时间", alignRight: false },
  { id: "" },
];

const moreMenus = [
  // { title: "编辑", icon: personOutline },
  // { title: "发工资", icon: personOutline },
];

const ratioMap = {
  1: "3%",
  2: "3%",
  3: "4%",
  4: "5%",
  5: "5%",
};

export default function TiejunMonthList() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [targetUser, setTargetUser] = useState({});
  const [action, setAction] = useState("");

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  const [form, setForm] = useState({
    uid: "",
    orgId: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/user/tiejun/performance",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  function getMenus(row) {
    return moreMenus.filter((menu) => {
      if (menu.condition) {
        switch (menu.condition) {
          case "pid":
            return !menu.pid;
        }
      }
      return true;
    });
  }

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      setTargetUser(row);
      setAction("edit");
    } else if (type === "发工资") {
      setTargetUser(row);
      setAction("pay");
    } else if (type === "解除") {
      handleDel(row);
    } else if (type === "设置辅导员") {
      setTargetUser(row);
      setAction("parent");
    }
  };

  function handleDel({ uid }) {
    Confirm({
      message: "确定解除铁军职位吗?",
      async onConfirm() {
        await asyncRequest({
          path: "/user/tiejun/del",
          data: { uid },
        });

        getItems();
      },
    });
  }

  function handleAddStaff() {
    setAction("add");
  }

  function renderPerformance(data) {
    if (!data) return null;
    const { merCount, activeCount, status, performance } = data[0];
    return (
      <Stack>
        <Typography>让利业绩：{performance}</Typography>
        <Typography>商户数量：{merCount}</Typography>
        <Typography>活跃数量：{activeCount}</Typography>
        <Typography>是否达标：{["否", "是"][status]}</Typography>
        {/* <Stack direction="row" alignItems="center">
          <Typography>是否达标：</Typography>
          <Typography>
            <TableCell align="left">
              <Label variant="ghost" color={["default", "success"][status]}>
                {["否", "是"][status]}
              </Label>
            </TableCell>
          </Typography>
        </Stack> */}
      </Stack>
    );
  }

  const isUserNotFound = items.length === 0;

  return (
    <Page title="铁军晋升">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            铁军晋升
          </Typography>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { id, uid, parent, user, realname, level, pointsSalary, lastMonthly2, lastMonthly, monthly, acceleration, createdAt, status } = row;
                    const isItemSelected = selected.indexOf(realname) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                        {/* <TableCell padding="checkbox">
                           <Checkbox
                             checked={isItemSelected}
                             onChange={(event) => handleClick(event, uid)}
                           />
                         </TableCell> */}
                        <TableCell component="th" scope="row">
                          <UserInfo {...user} enablePreview />
                        </TableCell>
                        {/* <TableCell align="left">{realname}</TableCell>
                        <TableCell align="left">{mobile}</TableCell> */}
                        <TableCell align="left">{TIEJUN_LEVEL_MAP[level]}</TableCell>
                        <TableCell align="left">{renderPerformance(lastMonthly2)}</TableCell>
                        <TableCell align="left">{renderPerformance(lastMonthly)}</TableCell>
                        <TableCell align="left">{renderPerformance(monthly)}</TableCell>

                        {/* <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell> */}

                        <TableCell align="right">
                          <MoreMenu spread={true} menus={getMenus(row)} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>

      {action === "add" && (
        <TiejunAddDialog
          action={action}
          open
          staff={targetUser}
          onClose={() => setAction("")}
          onUpdate={() => {
            getItems();
            setAction("");
          }}
        />
      )}

      {action === "edit" && (
        <TiejunEditDialog
          action={action}
          open
          tiejun={targetUser}
          onClose={() => setAction("")}
          onUpdate={() => {
            getItems();
            setAction("");
          }}
        />
      )}

      {/* <TitleDialog
        open={action === "title"}
        onClose={() => setAction("")}
        onUpdate={() => {
          getItems();
          setAction("");
        }}
        user={targetUser}
      /> */}

      {action === "parent" && (
        <BindTeijunParentDialog
          open
          onClose={() => setAction("")}
          onReload={() => {
            getItems();
            setAction("");
          }}
          tiejun={targetUser}
        />
      )}
    </Page>
  );
}
